/**
 * Boxes as printed on ICS 235-CG (Jan 2026), Facility Needs Assessment.
 *
 * Boxes 4, 5 and 6 are the three headings of one grid — Location and ICS
 * Element down the left, Requirements across the top — so the card renders
 * them as a single box titled with all three.
 *
 * Client mirror of `services/coms/src/routes/Forms/ICS_CG/forms/ics235FieldMap.ts`;
 * the two must agree or a typed value prints in the wrong cell.
 */
export const ICS235_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  needsGrid: '4. Location / 5. ICS Element / 6. Requirements',
  comments: '7. Comments:',
  preparedBy: '8. Prepared By:',
} as const;

/** Rows, in printed order. The last two are typed by the incident. */
export const ICS235_ELEMENT_ROWS = [
  { location: 'ICP', element: 'Unified Command' },
  { location: 'ICP', element: 'Liaison Officer & Agency Reps' },
  { location: 'ICP', element: 'Safety Officer' },
  { location: 'ICP', element: 'Public Information Officer' },
  { location: 'ICP', element: 'Planning Section' },
  { location: 'ICP', element: 'Operations Section' },
  { location: 'ICP', element: 'Logistics Section' },
  { location: 'ICP', element: 'Finance and Admin Section' },
  { location: 'ICP', element: 'Intel/Investigation Section' },
  { location: 'JIC', element: 'Joint Information Center' },
  { location: '', element: '' },
  { location: '', element: 'Total Needed:' },
] as const;

/** Columns, in printed order. The trailing three are blank for local additions. */
export const ICS235_REQUIREMENT_COLUMNS = [
  '# Expected Personnel',
  'Internal Workspace Sq ft',
  'Linear Wall Space',
  'Multi-purpose Meeting Rm',
  'External Sq ft',
  'Climate Control (HVAC)',
  '# Parking Spaces',
  'Rest Rooms',
  'Work Tables',
  'Conference Tables',
  'Chairs',
  'Speaker Phones',
  'Printer (B&W)',
  'Printer (color)',
  'High-speed Copier',
  'Poster Printer',
  'Landline Telephones',
  'Facsimile',
  'Video Projector',
  'Paper Shredder',
  'Charging Stations',
  'File Cabinets',
  '',
  '',
  '',
] as const;

/** Index of the first column the incident names itself. */
export const ICS235_FIRST_SPARE_COLUMN = 22;

/** Index of the row the incident names itself. */
export const ICS235_SPARE_ROW = 10;
